import React from 'react';

import { Avatar, useChannelPreviewInfo, useChannelStateContext } from 'stream-chat-react';

import { chatStore } from '../../../../../shared/stores/chatStore';
import classes from './CustomChannelHeader.module.scss';

const CustomChannelHeader = () => {
  const { channel } = useChannelStateContext('CustomChannelHeader');
  const { displayImage, displayTitle } = useChannelPreviewInfo({ channel });

  const currentUserId = chatStore.user?.id;
  const otherMember = Object.values(channel.state.members).find(
    ({ user }) => user?.id !== currentUserId,
  );
  const isOnline = otherMember?.user?.online ?? false;

  return (
    <div className={`str-chat__channel-header ${classes.header}`}>
      <Avatar
        className="str-chat__avatar--channel-header"
        image={displayImage}
        name={displayTitle}
      />
      <div className="str-chat__channel-header-end">
        <p className="str-chat__channel-header-title">{displayTitle}</p>
        <p className="str-chat__channel-header-subtitle">
          {isOnline ? 'Online' : 'Offline'}
        </p>
      </div>
    </div>
  );
};

export { CustomChannelHeader };
